;(function () {
  var DURATION_MS = 300
  var CONTENT = '.accordion__content'
  var CONTENT_INNER = '.accordion__content-inner'

  var WRAPPERS = [
    { selector: '.collapsible-content-faq', singleOpen: true },
    { selector: '.product__info-container', singleOpen: false },
  ]

  function findWrapper(details) {
    for (var i = 0; i < WRAPPERS.length; i++) {
      var wrapper = details.closest(WRAPPERS[i].selector)
      if (wrapper) return { el: wrapper, config: WRAPPERS[i] }
    }
    return null
  }

  function isAnimatedAccordion(details) {
    var content = details.querySelector(CONTENT)
    return !!(content && content.querySelector(CONTENT_INNER))
  }

  function animateOpen(details) {
    var found = findWrapper(details)
    if (!found) return

    var content = details.querySelector(CONTENT)
    var summary = details.querySelector('summary')

    if (found.config.singleOpen) {
      found.el.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== details && isAnimatedAccordion(other)) animateClose(other)
      })
    }

    details.setAttribute('open', '')
    if (summary) summary.setAttribute('aria-expanded', 'true')
    if (!content) return

    content.classList.add('is-opening')
    content.offsetHeight
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.classList.remove('is-opening')
      })
    })
  }

  function animateClose(details, onDone) {
    var content = details.querySelector(CONTENT)
    if (!content) {
      if (onDone) onDone()
      return
    }
    content.classList.add('is-closing')
    details.classList.add('is-closing')
    function finish() {
      content.removeEventListener('transitionend', finish)
      details.removeAttribute('open')
      details.classList.remove('is-closing')
      var sum = details.querySelector('summary')
      if (sum) sum.setAttribute('aria-expanded', 'false')
      if (onDone) onDone()
      requestAnimationFrame(function () {
        content.classList.remove('is-closing')
      })
    }
    content.addEventListener('transitionend', finish)
    setTimeout(finish, DURATION_MS + 50)
  }

  function initAccordionAnimate() {
    if (document.body.dataset.accordionAnimateInit) return
    document.body.dataset.accordionAnimateInit = '1'

    document.addEventListener(
      'click',
      function (e) {
        for (var i = 0; i < WRAPPERS.length; i++) {
          var selector = WRAPPERS[i].selector
          var openSummary = e.target.closest(selector + ' details[open] summary')
          if (openSummary) {
            var openDetails = openSummary.parentElement
            if (!isAnimatedAccordion(openDetails)) return
            e.preventDefault()
            animateClose(openDetails)
            return
          }

          var closedSummary = e.target.closest(selector + ' details:not([open]) summary')
          if (closedSummary) {
            var closedDetails = closedSummary.parentElement
            if (!isAnimatedAccordion(closedDetails)) return
            e.preventDefault()
            animateOpen(closedDetails)
            return
          }
        }
      },
      true
    )
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionAnimate)
  } else {
    initAccordionAnimate()
  }
})()
